var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-card-title"},[_c('v-container',{staticClass:"grey lighten-2 fill-height",attrs:{"fluid":""}},[_c('v-row',{staticClass:"fill-height"},[_c('v-col',{staticClass:"align-end flexbox",attrs:{"cols":"12"}},[_c('page-sub-title',{attrs:{"title":_vm.title}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }